module.exports = __webpack_public_path__ + "static/tooltip1_2-891973cee9c7f4fe7271941475c27950.png";